import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { motion } from 'framer-motion';

const Contact = ({ darkMode }) => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [isSent, setIsSent] = useState(false);

  // Directly apply dark mode class without transition
  const bgColor = darkMode ? "bg-[#1c1c1c]" : "bg-[#f5f3eb]";

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // Handle Form Submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;

    emailjs.send(
      'service_oxrcdzt',
      'template_iifc43a',
      {
        from_name: form.name,
        from_email: form.email,
        message: form.message,
        to_email: "kuradigital.contact@gmail.com",
      },
      '_nPndQ7P9oB99wMZG'
    )
    .then(() => {
      setIsSent(true);
      setForm({ name: '', email: '', message: '' });
    })
    .catch(() => {
      alert('Failed to send message. Please try again later.');
    });
  };

  return (
    <div className={`w-full min-h-screen flex flex-col items-center justify-center px-6 py-16 ${bgColor} text-black dark:text-white`}>
      
      {/* Contact Card */}
      <motion.div 
        className="p-10 rounded-lg shadow-lg max-w-2xl w-full mx-auto bg-white dark:bg-gray-900 bg-opacity-80 dark:bg-opacity-80 transition-all duration-300"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="text-4xl font-bold mb-6 text-center text-[#4b534e] dark:text-white">
          Enquire Here
        </h2>

        {/* Alternative Contact Method */}
        <p className="text-center text-gray-600 dark:text-gray-300 text-lg mb-4">
          Alternatively, reach us at <span className="font-semibold text-[#e5471f] dark:text-[#7fc7e6]">kuradigital.contact@gmail.com</span>
        </p>

        <div className="flex items-center mb-6">
          <div className="flex-grow border-t border-gray-300"></div>
          <span className="mx-4 text-gray-500 dark:text-gray-400">Or</span>
          <div className="flex-grow border-t border-gray-300"></div>
        </div>

        {/* Success Message */}
        {isSent && (
          <motion.p 
            className="text-center text-green-500 mb-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            Your message has been sent successfully!
          </motion.p>
        )}

        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <motion.div 
            className="relative"
            whileHover={{ scale: 1.02 }}
          >
            <label className="block text-gray-700 dark:text-gray-200 font-semibold mb-2">
              Name
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your Name"
                className="w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none 
                           focus:ring-2 focus:ring-[#7fc7e6] dark:bg-gray-800 dark:border-gray-600 dark:text-white"
              />
            </label>
          </motion.div>

          <motion.div 
            className="relative"
            whileHover={{ scale: 1.02 }}
          >
            <label className="block text-gray-700 dark:text-gray-200 font-semibold mb-2">
              Email
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Your Email"
                className="w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none 
                           focus:ring-2 focus:ring-[#7fc7e6] dark:bg-gray-800 dark:border-gray-600 dark:text-white"
              />
            </label>
          </motion.div>

          <motion.div 
            className="relative"
            whileHover={{ scale: 1.02 }}
          >
            <label className="block text-gray-700 dark:text-gray-200 font-semibold mb-2">
              Message
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Your Message"
                className="w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none 
                           focus:ring-2 focus:ring-[#7fc7e6] dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                rows="5"
              ></textarea>
            </label>
          </motion.div>

          {/* Submit Button with Animation */}
          <motion.button
            type="submit"
            className="w-full p-3 bg-[#4b534e] text-white dark:bg-[#e5471f] rounded-md shadow-md transition-all duration-300 relative overflow-hidden"
            disabled={isSent}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="absolute inset-0 w-full h-full bg-[#e5471f] dark:bg-[#4b534e] opacity-0 transition-opacity duration-300 group-hover:opacity-20"></span>
            <span className="relative">Send Message</span>
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
};

export default Contact;

